var _style, _script, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 17",
    style: {
      enableBackground: "new 0 0 18 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F79317;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#207EFF;stroke:#F79317;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _script || (_script = /*#__PURE__*/React.createElement("script", {
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb",
    id: "argent-x-extension",
    xmlns: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,9.2h-4v-8h12v5.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,8.5v2.7c0,1.1,1.8,2,4,2s4-0.9,4-2V8.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,11.2v2.7c0,1.1,1.8,2,4,2s4-0.9,4-2v-2.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,10.5c2.2,0,4-0.9,4-2s-1.8-2-4-2c-2.2,0-4,0.9-4,2S10.1,10.5,12.3,10.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,5.8c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7C7.3,4.5,7,4.8,7,5.2C7,5.5,7.3,5.8,7.7,5.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.7,5.8c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7C7.3,4.5,7,4.8,7,5.2C7,5.5,7.3,5.8,7.7,5.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.57f643b0296a683e3e63a1f31b50456a.svg";
export { ForwardRef as ReactComponent };